import { IdentifyOptions } from '@userpilot/capacitor'
import { isPlatformNative } from '../../utilities/platform.util'
import { isUserpilotEnabled } from './initialize'
import Logger from '../../services/logger.service'
import { Userpilot as userPilotNative } from '@userpilot/capacitor'
import { Userpilot as userPilotWeb } from 'userpilot'

export const identifyUserForUserPilot = (userId: string, username: string) => {
  if (!isUserpilotEnabled()) {
    Logger.info('Userpilot is not enabled, skipping identify')
    return
  }

  const identifyOptions: IdentifyOptions = {
    userId: String(userId),
    properties: {
      name: username.toLowerCase(),
    },
  }
  try {
    if (isPlatformNative()) {
      userPilotNative.identify(identifyOptions)
      Logger.info(`Userpilot native identify success for userId: ${userId}`)
    } else {
      userPilotWeb.identify(userId, identifyOptions.properties)
      Logger.info(`Userpilot WEB identify success for userId: ${userId}`)
    }
  } catch (err) {
    Logger.errorObj(`Userpilot identify failed error: `, err)
  }
}
